"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventorySubject = exports.InventorySubjectType = void 0;
const ddd_1 = require("../../../infrastructure/ddd");
const utils_1 = require("@leavy/utils");
var InventorySubjectType;
(function (InventorySubjectType) {
    InventorySubjectType["ROOM"] = "ROOM";
    InventorySubjectType["VALUABLE_OBJECT"] = "VALUABLE_OBJECT";
})(InventorySubjectType = exports.InventorySubjectType || (exports.InventorySubjectType = {}));
class InventorySubject extends ddd_1.AggregateRootBase {
    constructor(id, data) {
        super(id);
        this.photos = [];
        this.initialize(data);
    }
    isComplete() {
        return (utils_1.Guard.isNotNullish(this.name) && utils_1.Guard.String.isNotEmpty(this.name)
            && utils_1.Guard.isNotNullish(this.type) && utils_1.Guard.Enum.isEnumMember(InventorySubjectType)(this.type)
            && utils_1.Guard.isNotNullish(this.photos) && this.photos.length > 0);
    }
    toPlain() {
        return { ...this };
    }
}
exports.InventorySubject = InventorySubject;
//# sourceMappingURL=InventorySubject.js.map